import LearnPageLayout from "@/components/LearnPageLayout";
import { pageSaintEastCoast } from "./learnDataSaintEastCoast";

const SaintEastCoastPage = () => (
  <LearnPageLayout
    title={pageSaintEastCoast.title}
    description={pageSaintEastCoast.description}
    canonical={pageSaintEastCoast.canonical}
    h1={pageSaintEastCoast.h1}
    breadcrumbLabel={pageSaintEastCoast.breadcrumbLabel}
    crumbs={pageSaintEastCoast.crumbs}
    shortAnswer={pageSaintEastCoast.shortAnswer}
    keyTakeaways={pageSaintEastCoast.keyTakeaways}
    sections={pageSaintEastCoast.sections}
    faqs={pageSaintEastCoast.faqs}
    sources={pageSaintEastCoast.sources}
    schemaJson={pageSaintEastCoast.schemaJson}
    relatedLinks={pageSaintEastCoast.relatedLinks}
    reviewBlock={pageSaintEastCoast.reviewBlock}
  />
);

export default SaintEastCoastPage;
